import ModalBody from "Components/Common/Modal/ModalBody"
import ModalContainer from "Components/Common/Modal/ModalContainer"
import ModalFooter from "Components/Common/Modal/ModalFooter"
import ModalHeader from "Components/Common/Modal/ModalHeader"
import FillButton from "Components/Common/components/Button/FillButton"
import OutlineButton from "Components/Common/components/Button/OutlineButton"
import Label from "Components/Common/components/Label"
import { AppContext } from "Context/AppContext"
import React, { useContext, useState } from "react"
import LoadingSuccessErrorAlert from "../components/LoadingSuccessErrorAlert"
import ConfirmBulkDelete from "./ConfirmBulkDelete"
import { deleteProductsByPDW } from "api/Pdw"
import { toast } from "react-toastify"
import { checkJobStatus } from "api/Job"
import ProductDeleteXlsModal from "../ProductDeleteXlsModal"

type MyProps = {
  isOpen: boolean,
  onClose: Function
  fetchData: Function
}

const BulkDeleteXLSModal = ({
  isOpen,
  onClose,
  fetchData
}: MyProps) => {
    const appData = useContext(AppContext)
    const channelKey = appData?.channelKey;
    const [selectedFile, setSelectedFile] = useState<File|null>(null)
    const [confirmModal, setConfirmModal] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [progressModal, setProgressModal] = useState<boolean>(false)
    const [validatingXls, setValidating] = useState(false);
    const [deleteStatus, setDeleteStatus] = useState("");
    const [productDelete, setProductDelete] = useState({
      deletedCount: 0,
      notDeletedCount: 0,
    });
    const [downloadUrl, setDownloadUrl] = React.useState("");

    const [productDeleteLog, setProductDeleteLog] = useState("");


    async function handle_file_selection (event: React.ChangeEvent<HTMLInputElement>) {
      event.preventDefault();
      const file = (event.target as any).files[0];
      const totalCount = await appData.checkSelectedFile(file, file.type);
      if (totalCount > 0) {
        setSelectedFile(file);
      } else {
        setSelectedFile(null);
      }
    }

    const openConfirmModal = () => {
      setConfirmModal(true)
    }


    const handleConfirm = async () => {
      if(!selectedFile) return
      setLoading(true)
      setValidating(true);
      setProgressModal(true)
      setConfirmModal(false)

      deleteProductsByPDW(selectedFile, channelKey)
      .then(({ jobid, message }) => {
        setValidating(false)

        checkJobStatus(jobid)
        .then((res: any) => {
          setDeleteStatus(res.status);
  
          if (res?.data) {
            setProductDelete({
              deletedCount: res.data.deleted_products_count,
              notDeletedCount: res.data.product_not_delete_count,
            });
            setProductDeleteLog(res.data.url);
          }
          else {
            setProductDelete({
              deletedCount: 0,
              notDeletedCount: 0,
            });
          }
  
        })
        .catch((err) => {
          toast.error(err.message ?? "Error deleting products");
          setProgressModal(false);
        })
      })
      .catch((err) => {
        toast.error(err ?? "Error in deleting")
        setProgressModal(false)
      })
      
      setLoading(false)
    }

    const closeDelModal = () => {
      setProgressModal(false);
      fetchData();
      setDeleteStatus("");
      setProductDeleteLog("");
      setTimeout(() => {
        setDownloadUrl("");
      }, 5000);
    };

    if(progressModal)
      return (
        <ProductDeleteXlsModal
            showPopup={progressModal}
            validating={validatingXls}
            status={deleteStatus}
            productDeleteLog={productDeleteLog}
            closeDelModal={closeDelModal}
            setDownloadUrl={setDownloadUrl}
            productDelete={productDelete}
            isManualDel={false}
          />
        )

    if(confirmModal) 
      return <ConfirmBulkDelete 
        isOpen={confirmModal} 
        onClose= {() => setConfirmModal(false)}
        handleConfirm = {handleConfirm}
        loading = {loading}
        />

    return (
      <ModalContainer isOpen={isOpen} setOpen={onClose} width='500px'>
        <ModalHeader>
        <div>
            <Label
              message={"Upload XLS - Bulk Delete"}
              fontSize={"0.875"}
              fontWeight="600"
            />
          </div>
        </ModalHeader>

        <ModalBody>
          <div className="tw-border tw-border-dashed tw-py-5 tw-relative">
          {
            !selectedFile && 
            <label
                className="cursor-pointer"
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "400",
                  color: "#091CAA",
                }}
              >
                <input
                  type="file"
                  id="fupload"
                  style={{ display: "none" }}
                  onChange={(event) => handle_file_selection(event)}
                />
                {/* <i className="fa fa-cloud-upload fa-x"></i> */}
                <Label
                  message={
                    "Drag and drop XLS file to delete products"
                  }
                  color={"#172B4D"}
                  fontSize={"0.75"}
                  fontWeight={"400"}
                />
                <p>Browse File</p>
              </label>
          }

          {
          selectedFile && (
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-py-5">
              <span className="">
                <svg
                  width="28"
                  height="27"
                  viewBox="0 0 28 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.03514 24.9819C0.03514 17.322 0.03514 9.66352 0.03514 2.00359C0.275599 1.24166 0.778246 0.741908 1.53873 0.5C4.88778 0.5 8.23682 0.5 11.5859 0.5C11.5902 0.650649 11.5989 0.79985 11.5989 0.950499C11.5989 2.68441 11.6004 4.41832 11.5989 6.15224C11.5989 6.76497 11.7959 7.2908 12.2623 7.70363C12.6592 8.05418 13.13 8.186 13.6486 8.186C15.0624 8.186 16.4762 8.186 17.8885 8.186C18.3231 8.186 18.3332 8.19759 18.3347 8.61622C18.3361 8.97691 18.3361 9.3376 18.3347 9.69828C18.3332 10.1242 18.3245 10.1328 17.8943 10.1343C17.564 10.1357 17.2323 10.1343 16.902 10.1343C14.5264 10.1343 12.1508 10.1285 9.77373 10.1372C8.08038 10.143 6.81724 11.3337 6.79407 12.9981C6.7622 15.2535 6.7651 17.5089 6.79407 19.7643C6.8129 21.2592 7.82543 22.36 9.29861 22.5788C9.51589 22.6106 9.73752 22.6208 9.9577 22.6208C12.6143 22.6237 15.271 22.6208 17.9276 22.6237C18.3173 22.6237 18.3332 22.6425 18.3347 23.0322C18.3376 23.5537 18.3419 24.0751 18.3332 24.5952C18.3158 25.6497 17.4902 26.4913 16.4356 26.4928C11.5931 26.5 6.75206 26.5014 1.90956 26.4899C1.10417 26.4884 0.530544 26.0669 0.18434 25.3397C0.127847 25.2224 0.0829421 25.0993 0.0336914 24.979L0.03514 24.9819Z"
                    fill="#8993A4"
                  />
                  <path
                    d="M12.6084 0.5C13.1227 1.19096 13.7122 1.81963 14.2699 2.47582C15.5215 3.94755 16.7846 5.41058 18.0419 6.87651C18.081 6.92142 18.1202 6.96777 18.1549 7.01702C18.1926 7.07207 18.2723 7.11987 18.2317 7.19664C18.194 7.26907 18.1086 7.24879 18.0405 7.24879C16.5181 7.24879 14.9971 7.25603 13.4747 7.24444C12.9633 7.2401 12.5461 6.8345 12.5432 6.32751C12.5346 4.38501 12.5447 2.44395 12.5476 0.501449H12.6084V0.5Z"
                    fill="#8993A4"
                  />
                  <path
                    d="M17.858 11.0744C20.5248 11.0744 23.1916 11.0744 25.8584 11.0744C27.1823 11.0744 27.9631 11.8595 27.9631 13.1922C27.9631 15.3273 27.9631 17.4625 27.9631 19.5976C27.9631 20.8883 27.1722 21.6864 25.8902 21.6864C20.5263 21.6864 15.1623 21.6864 9.79831 21.6864C8.52793 21.6864 7.72399 20.8897 7.72399 19.6281C7.72254 17.4625 7.72254 15.2969 7.72399 13.1328C7.72399 11.8711 8.52793 11.0758 9.79686 11.0744C12.4839 11.0729 15.171 11.0744 17.858 11.0744V11.0744ZM23.6117 19.7352C23.7623 19.7352 23.913 19.7381 24.0622 19.7352C25.1616 19.7063 26.0177 18.8589 26.0076 17.8116C25.9974 16.7715 25.1529 15.9429 24.068 15.9154C23.7478 15.9067 23.4263 15.9212 23.1061 15.9082C22.5658 15.885 22.1631 15.4606 22.1646 14.9319C22.1675 14.4031 22.5731 13.986 23.1163 13.9657C23.4263 13.9541 23.7377 13.9584 24.0491 13.9628C24.5416 13.97 24.8734 14.1888 25.0283 14.6537C25.0993 14.8681 25.2138 14.942 25.4224 14.9246C25.5324 14.9159 25.6425 14.9203 25.7526 14.9217C25.9583 14.9261 26.0047 14.8261 25.9771 14.6349C25.8729 13.9034 25.2645 13.2486 24.5228 13.0835C24.0767 12.9836 23.6233 13.0212 23.1742 13.0285C22.0878 13.0473 21.2404 13.8788 21.2288 14.9188C21.2172 15.9705 22.0675 16.8164 23.1699 16.8454C23.49 16.8541 23.8116 16.8396 24.1317 16.8526C24.672 16.8758 25.0747 17.3017 25.0718 17.829C25.0689 18.3562 24.6619 18.7749 24.1201 18.7937C23.8101 18.8053 23.4987 18.8009 23.1872 18.7966C22.6962 18.7893 22.3616 18.5663 22.208 18.1042C22.137 17.8898 22.0226 17.8159 21.814 17.8333C21.7039 17.842 21.5938 17.8376 21.4838 17.8362C21.2795 17.8319 21.2317 17.9318 21.2592 18.1245C21.3635 18.856 21.9719 19.5093 22.7136 19.6773C23.0105 19.7439 23.3104 19.7367 23.6117 19.7352V19.7352ZM10.2445 13.0256C9.69836 13.0256 9.69546 13.0285 9.94751 13.4688C10.4096 14.2786 10.8529 15.0999 11.3425 15.8922C11.5612 16.2471 11.5568 16.5195 11.3396 16.8729C10.8268 17.7102 10.3546 18.5721 9.87074 19.4267C9.82293 19.5122 9.7056 19.615 9.84176 19.7135C10.033 19.8511 10.6269 19.6976 10.7486 19.4861C11.1281 18.8256 11.5047 18.1636 11.8842 17.503C12.0537 17.2104 12.0783 17.209 12.2435 17.4929C12.5897 18.0911 12.9547 18.6807 13.2647 19.2978C13.4472 19.6614 13.6891 19.7816 14.0744 19.741C14.3888 19.7077 14.4148 19.6889 14.2555 19.4093C13.8586 18.7126 13.5138 17.9782 13.0474 17.3307C12.5607 16.6542 12.5679 16.1008 13.0489 15.4273C13.5182 14.7696 13.8702 14.0294 14.27 13.3211C14.3163 13.2385 14.4366 13.1313 14.2772 13.043C14.031 12.9053 13.5051 13.0647 13.3617 13.3138C12.9924 13.957 12.6259 14.6016 12.2565 15.2447C12.0769 15.5562 12.0566 15.5576 11.8828 15.2549C11.5221 14.6291 11.1542 14.0091 10.8123 13.3732C10.6703 13.1096 10.5023 12.9633 10.243 13.0256H10.2445ZM15.4505 16.3775C15.4505 17.3698 15.4578 18.362 15.4462 19.3528C15.4433 19.6353 15.5302 19.7454 15.8243 19.741C16.6456 19.7266 17.4669 19.7367 18.2897 19.7367C18.8401 19.7367 19.392 19.7323 19.9425 19.7367C20.1409 19.7381 20.2467 19.6643 20.2366 19.4557C20.2337 19.3963 20.2366 19.3354 20.2366 19.2761C20.2366 18.9603 20.0825 18.8019 19.7745 18.8009C18.7923 18.8009 17.8102 18.8009 16.8281 18.8009C16.3964 18.8009 16.3863 18.7908 16.3863 18.3664C16.3863 16.7136 16.3805 15.0593 16.3907 13.4065C16.3921 13.1212 16.2994 12.9923 16.0097 13.0256C15.9503 13.0328 15.8895 13.0328 15.8301 13.0256C15.5433 12.9923 15.4419 13.1139 15.4462 13.4036C15.4592 14.3959 15.4505 15.3867 15.4505 16.379V16.3775Z"
                    fill="#8993A4"
                  />
                </svg>
              </span>
              <span className="new-uploaded-file-name tw-mt-3">
                {selectedFile.name}
              </span>
              <span
                className="tw-cursor-pointer tw-absolute tw-top-1 tw-right-1"
                onClick={(e) => {
                  setSelectedFile(null);
                  // setXlsCount(0);
                }}
              >
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0001 5L5.00006 14"
                    stroke="#172B4D"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.00006 5L14.0001 14"
                    stroke="#172B4D"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          )}
        </div>
        <div className="mt-2">
          <LoadingSuccessErrorAlert loading={loading} />
        </div>

        <iframe
          style={{ display: "none" }}
          src={downloadUrl}
          id="iframe_pdw_upload"
          title="Delete PDW"
          />
        </ModalBody>

        <ModalFooter>
          <div className="min-w-full tw-space-x-3 tw-justify-end tw-flex">
            <OutlineButton onClick={() => onClose()}>Cancel</OutlineButton>
            <FillButton disabled={confirmModal} onClick={openConfirmModal}>Upload</FillButton>
          </div>
        </ModalFooter>
      </ModalContainer>
    )
}

export default BulkDeleteXLSModal